import { nameValidation } from "@validations/name";
import { validationOfRequired } from "@validations/required";
import { useFormContext } from "react-hook-form";
import { FormRow } from "@components/FormRow";
import Input from "@components/Input";
import { PredefinedToolTips, ToolTip } from "@components/ToolTip";
import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  required?: boolean;
  request?: boolean;
};

export type NameInputForm = {
  lastNameKana: string;
  firstNameKana: string;
  lastName: string;
  firstName: string;
};

const NameInput: FC<Props> = ({ required, request }) => {
  const {
    control,

    formState: { errors },
  } = useFormContext<NameInputForm>();

  const label = request ? "予約者氏名" : "氏名";

  return (
    <>
      <FormRow
        label={`${label} (漢字)`}
        value={
          <div className={styles.flex}>
            <Input
              inputClassName={styles.input}
              name="lastName"
              control={control}
              defaultValue=""
              type="text"
              error={errors.lastName}
              placeholder="山田"
              rules={{
                ...nameValidation.name,
                required: required && validationOfRequired,
              }}
            />
            <Input
              inputClassName={styles.input}
              name="firstName"
              control={control}
              defaultValue=""
              type="text"
              error={errors.firstName}
              placeholder="太郎"
              rules={{
                ...nameValidation.name,
                required: required && validationOfRequired,
              }}
            />
          </div>
        }
        valueError={errors.lastName?.message || errors.firstName?.message}
        toolTip={<ToolTip toolTip={PredefinedToolTips.name} />}
      />
      <FormRow
        label={`${label} (かな)`}
        value={
          <div className={styles.flex}>
            <Input
              inputClassName={styles.input}
              name="lastNameKana"
              control={control}
              defaultValue=""
              type="text"
              error={errors.lastNameKana}
              placeholder="やまだ"
              rules={{
                ...nameValidation.nameKana,
                required: required && validationOfRequired,
              }}
            />
            <Input
              inputClassName={styles.input}
              name="firstNameKana"
              control={control}
              defaultValue=""
              type="text"
              error={errors.firstNameKana}
              placeholder="たろう"
              rules={{
                ...nameValidation.nameKana,
                required: required && validationOfRequired,
              }}
            />
          </div>
        }
        valueError={
          errors.lastNameKana?.message || errors.firstNameKana?.message
        }
        toolTip={<ToolTip toolTip={PredefinedToolTips.nameKana} />}
      />
    </>
  );
};

export default NameInput;
